import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import heroBackground from "@/assets/hero-bg.jpg";
import conversiaLogo from "@/assets/conversia-logo-light.svg";

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden px-4 sm:px-6">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${heroBackground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.15
        }}
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-background/95 via-background/98 to-background z-0" />
      
      {/* Content */}
      <div className="container relative z-10 mx-auto px-4 sm:px-6 py-16 sm:py-20">
        <div className="max-w-5xl mx-auto text-center space-y-6 sm:space-y-8">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <img src={conversiaLogo} alt="Convers•IA" className="h-auto w-80" />
          </div>
          
          {/* Main Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold leading-tight">
            La Nueva Era de la{" "}
            <span className="text-primary">Interacción</span>
            <br />
            con el Cliente
          </h1>
          
          {/* Subtitle */}
          <p className="text-lg sm:text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto font-medium">
            Agentes de Inteligencia Artificial construidos a la medida de sus objetivos,
            capaces de manejar una amplia gama de tareas empresariales.
          </p>
          
          {/* Value Proposition */}
          <div className="bg-card border border-border rounded-xl p-5 sm:p-6 max-w-3xl mx-auto shadow-lg">
            <p className="text-lg md:text-xl text-foreground">
              <span className="text-primary font-semibold">Transformamos la Experiencia de tus Clientes.</span>
              {" "}Combinamos la eficiencia de la automatización con la calidez del trato humano,
              ofreciendo una experiencia de cliente sin igual.
            </p>
          </div>
          
          {/* CTA Button */}
            <div className="pt-6">
              <a
                href="./Folleto_MadeConversIA.pdf"
                target="_blank"
                rel="noopener noreferrer"
                download="Folleto_MadeConversIA.pdf"
              >
                <Button variant="cta" size="lg" className="w-full sm:w-auto text-base sm:text-lg px-6 sm:px-8 py-5 h-auto">
                  Descargar folleto
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </a>
            </div>
        </div>
      </div>
      
  {/* Bottom Gradient */}
  <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent z-10 pointer-events-none" />
    </section>
  );
};

export default Hero;
